import { useFetch as e } from "../../../utils/http-client.mjs";
import { COMMON_DATA_FILES_VALIDATION_API_PATH as t, DATA_FILES_VALIDATION_API_PATH as n, PUBLIC_DATA_FILES_VALIDATION_API_PATH as r, getActivateCommonFilePath as i, getActivateFilePath as a, getActivatePublicFilePath as o, getRemoveDraftCommonFilePath as s, getRemoveDraftFilePath as c } from "../api/index.mjs";
import { RequestMethodsEnum as l } from "@systemeio/util";
import u from "axios";
//#region src/modules/file-uploader/hooks/use-file-uploader-actions.ts
var d = (d) => {
	let { fetcher: f } = e({ method: l.post }), { fetcher: p } = e({ method: l.post }), { fetcher: m } = e({ method: l.delete });
	return {
		validateAndGetUploadOptions: async ({ file: e, source: i, mimeType: a, cancelToken: o }) => await f(d?.isCommon ? t : d?.isPublic ? r : n, {
			source: i,
			fileName: e.name,
			fileSize: e.size,
			mimeType: a,
			isCommon: d?.isCommon ?? !1
		}, { cancelToken: o }),
		uploadToFileStore: async ({ file: e, uploadOptions: t, progressHandler: n, cancelToken: r }) => {
			let i = new FormData();
			return i.append("key", t.key), i.append("acl", t.acl), i.append("X-Amz-Credential", t.credential), i.append("X-Amz-Algorithm", t.algorithm), i.append("X-Amz-Date", t.date), i.append("Policy", t.policy), i.append("X-Amz-Signature", t.signature), i.append("Content-Type", t.contentType), i.append("Cache-Control", t.cacheControl), i.append("file", e), await u.post(t.url, i, {
				onUploadProgress: n,
				cancelToken: r
			});
		},
		activate: async ({ fileId: e, cancelToken: t }) => await p(d?.isCommon ? i(e) : d?.isPublic ? o(e) : a(e), {}, {
			cancelToken: t,
			headers: { "Content-Type": "application/json" }
		}),
		removeDraftFile: async (e) => await m(d?.isCommon ? s(e) : c(e))
	};
};
//#endregion
export { d as useFileUploaderActions };
